import React from 'react';
import { CreditCardIcon } from 'lucide-react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-153" data-mp="17ws0u4duseat">
      <div className="mx-auto max-w-md" data-id="element-154" data-mp="1mmqym61hxnpr">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-155" data-mp="1hopj1v3a46j1">
          Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-156" data-mp="u0ocustkp26s">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-157" data-mp="13x16jqp4bg1j">
            PILATES READY™ Complete System
          </span>

          <dl data-id="element-158" data-mp="2fav4osnzc2sz">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-159" data-mp="2add5vv3of3yp">
                <dt className="text-ink/80" data-id="element-160" data-mp="pmbh3vw3p661">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-161" data-mp="ui8v3vjw60fn">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-162" data-mp="zjpxjvi0xuyc">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-163" data-mp="13ip0jak73hn5">
                Total Value:
              </dt>
              <dd className="font-bold text-amber-700 line-through" data-id="element-164" data-mp="6vkbn5f8hzwx">
                $225 USD
              </dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-165" data-mp="ftw0b1wjinmq">
            Today only
          </p>
          <p className="flex items-baseline justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-166" data-mp="kmp6zvbkk61g">
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-167" data-mp="3k8dmwz0ysrps">
              $27
            </span>
            <span className="text-sm font-bold text-brand" data-id="element-168" data-mp="3o7uv407s02yn">USD</span>
          </p>

          <p className="mt-5 flex items-start justify-center gap-2 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-169" data-mp="vdnwio48m198">
            <CreditCardIcon className="mt-px h-3.5 w-3.5 shrink-0 text-ink/40" aria-hidden="true" data-id="element-170" data-mp="155afx7qqb6n2" />
            <span data-id="element-171" data-mp="107s3v8hf0bau">Payment will be processed in your local currency.</span>
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-172" data-mp="chxskvcquusp" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-173" data-mp="cipoy8e60wk1">
            Instant Download · One-Time Payment · Lifetime Access · 7-Day
            Guarantee
          </p>
        </div>
      </div>
    </section>;
}